export default "__VITE_ASSET__cvGftk4x__"